export default "__VITE_ASSET__DDZH9oQa__"